export enum BannerSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface IBannerData {
  size: BannerSize;
  showButtons: boolean;
  title: string;
  subtitle: string;
}

export interface IBannerDataCollection {
  [key: string]: IBannerData;
}
